import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.projects.filebrowser');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const require: any;
const showdown = require('showdown');

@Component({
    selector: 'wiz-page-projects-filebrowser',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.projects.filebrowser/view.scss */
:host {
  display: block;
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}

:host ::ng-deep .reviewops-markdown {
  color: #0f172a;
  font-size: 14px;
  line-height: 1.72;
}

:host ::ng-deep .reviewops-markdown > *:first-child {
  margin-top: 0;
}

:host ::ng-deep .reviewops-markdown > *:last-child {
  margin-bottom: 0;
}

:host ::ng-deep .reviewops-markdown h1,
:host ::ng-deep .reviewops-markdown h2,
:host ::ng-deep .reviewops-markdown h3,
:host ::ng-deep .reviewops-markdown h4 {
  margin: 1.4em 0 0.55em;
  font-weight: 700;
  line-height: 1.28;
}

:host ::ng-deep .reviewops-markdown h1 {
  font-size: 1.65em;
}

:host ::ng-deep .reviewops-markdown h2 {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.35em;
  font-size: 1.35em;
}

:host ::ng-deep .reviewops-markdown h3 {
  font-size: 1.15em;
}

:host ::ng-deep .reviewops-markdown p,
:host ::ng-deep .reviewops-markdown ul,
:host ::ng-deep .reviewops-markdown ol,
:host ::ng-deep .reviewops-markdown blockquote,
:host ::ng-deep .reviewops-markdown pre,
:host ::ng-deep .reviewops-markdown table {
  margin: 0.85em 0;
}

:host ::ng-deep .reviewops-markdown ul,
:host ::ng-deep .reviewops-markdown ol {
  padding-left: 1.45em;
}

:host ::ng-deep .reviewops-markdown code {
  border-radius: 4px;
  background: #f1f5f9;
  padding: 0.1em 0.28em;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.92em;
}

:host ::ng-deep .reviewops-markdown pre {
  overflow: auto;
  border-radius: 6px;
  background: #0f172a;
  padding: 14px;
  color: #e2e8f0;
}

:host ::ng-deep .reviewops-markdown pre code {
  background: transparent;
  padding: 0;
  color: inherit;
}

:host ::ng-deep .reviewops-markdown blockquote {
  border-left: 3px solid #cbd5e1;
  padding-left: 12px;
  color: #475569;
}

:host ::ng-deep .reviewops-markdown table {
  display: block;
  overflow: auto;
  width: 100%;
  border-collapse: collapse;
}

:host ::ng-deep .reviewops-markdown th,
:host ::ng-deep .reviewops-markdown td {
  border: 1px solid #e2e8f0;
  padding: 6px 8px;
}

:host ::ng-deep .reviewops-markdown img {
  max-width: 100%;
}`],
})
export class PageProjectsFilebrowserComponent implements OnInit, OnDestroy {
    public projectId: string = '';
    public adminMode: boolean = false;
    public project: any = null;
    public mode: string = '';
    public loading: boolean = true;
    public treeLoading: boolean = false;
    public error: string = '';
    public rootNode: any = this.blankRootNode();
    public activePath: string = '';
    public tabs: any[] = [];
    public activeTabPath: string = '';
    public savingPath: string = '';
    public downloadingPath: string = '';
    private destroyed: boolean = false;
    private markdownConverter: any = null;
    private markdownHtmlCache: any = {};
    private markdownHtmlCacheKeys: string[] = [];
    private editorOptionsCache: any = {
        readOnly: false,
        language: 'plaintext',
        automaticLayout: true,
        minimap: { enabled: false },
        lineNumbers: 'on',
        scrollBeyondLastLine: false,
        wordWrap: 'on',
        fontSize: 13,
        renderWhitespace: 'selection'
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        this.destroyed = false;
        await this.service.init();
        await this.service.auth.allow('/login');
        this.adminMode = this.routeAdminMode();
        const route = (window as any).WizRoute || {};
        const segment = route.segment || {};
        this.projectId = segment.id || '';
        this.markdownConverter = new showdown.Converter({
            tables: true,
            tasklists: true,
            strikethrough: true,
            simplifiedAutoLink: true,
            excludeTrailingPunctuationFromURLs: true,
            literalMidWordUnderscores: true,
            ghCodeBlocks: true,
            openLinksInNewWindow: true,
            backslashEscapesHTMLTags: true,
            disableForced4SpacesIndentedSublists: true,
            simpleLineBreaks: false
        });
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        document.title = 'SEASON::ReviewOps';
    }

    @HostListener('window:beforeunload', ['$event'])
    public beforeUnload(event: any) {
        if (!this.hasDirtyTabs()) return;
        event.preventDefault();
        event.returnValue = '';
    }

    public blankRootNode() {
        return {
            name: 'root',
            path: '',
            type: 'directory',
            is_directory: true,
            depth: 0,
            expanded: true,
            loaded: false,
            loading: false,
            children: []
        };
    }

    public async renderView() {
        if (this.destroyed) return;
        try {
            await this.service.render();
        } catch (e) { }
    }

    public routeAdminMode() {
        try {
            return new URLSearchParams(window.location.search).get('admin') === '1';
        } catch (e) {
            return false;
        }
    }

    public routeInitialPath() {
        try {
            return new URLSearchParams(window.location.search).get('path') || '';
        } catch (e) {
            return '';
        }
    }

    public requestParams(params: any = {}) {
        const query: any = Object.assign({}, params || {});
        if (this.adminMode) query.admin = '1';
        return query;
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.renderView();
        const { code, data } = await wiz.call('load', this.requestParams({ id: this.projectId }));
        if (code === 200) {
            this.project = data.project || null;
            this.mode = data.mode || '';
            document.title = `${this.projectName()} - 파일 브라우저`;
            await this.loadTree('', this.rootNode);
            const initialPath = this.routeInitialPath();
            if (initialPath) await this.revealPath(initialPath);
        } else {
            this.error = data.message || '프로젝트 파일 브라우저를 열 수 없습니다.';
        }
        this.loading = false;
        await this.renderView();
    }

    public projectName() {
        return this.project && this.project.name ? this.project.name : 'ReviewOps';
    }

    public projectTypeLabel() {
        return this.mode === 'html' ? 'HTML' : '웹서비스';
    }

    public async loadTree(path: string = '', node: any = null) {
        const targetPath = this.cleanPath(path);
        const targetNode = node || this.findTreeNode(targetPath) || this.rootNode;
        targetNode.loading = true;
        this.treeLoading = true;
        this.error = '';
        await this.renderView();
        const { code, data } = await wiz.call('load_project_files', this.requestParams({
            id: this.projectId,
            path: targetPath
        }));
        targetNode.loading = false;
        this.treeLoading = false;
        if (code === 200) {
            const browser = data.browser || { path: targetPath, root_label: 'root', items: [] };
            if (!targetPath) targetNode.name = browser.root_label || this.projectName();
            this.applyBrowserToNode(targetNode, browser);
        } else {
            this.error = data.message || '파일 목록을 불러오지 못했습니다.';
        }
        await this.renderView();
    }

    public applyBrowserToNode(node: any, browser: any) {
        const previous: any = {};
        for (const child of node.children || []) previous[child.path || ''] = child;
        const depth = Number(node.depth || 0) + 1;
        node.path = this.cleanPath(browser.path || node.path || '');
        node.children = (browser.items || []).map((item: any) => {
            const path = this.cleanPath(item.path || '');
            const old = previous[path] || {};
            return Object.assign({}, item, {
                path,
                depth,
                expanded: !!old.expanded,
                loaded: !!old.loaded,
                loading: false,
                children: old.children || []
            });
        });
        node.loaded = true;
        node.expanded = true;
    }

    public visibleTreeNodes() {
        const rows: any[] = [];
        const walk = (node: any) => {
            rows.push(node);
            if (!node || !node.is_directory || !node.expanded) return;
            for (const child of node.children || []) walk(child);
        };
        walk(this.rootNode);
        return rows;
    }

    public trackByPath(_index: number, item: any) {
        return item && item.path !== undefined ? `${item.type || ''}:${item.path}` : _index;
    }

    public treeNodeStyle(node: any) {
        return { paddingLeft: `${8 + Math.max(Number(node && node.depth || 0), 0) * 14}px` };
    }

    public treeRowClass(node: any) {
        const active = node && !node.is_directory && node.path === this.activePath;
        return [
            'flex h-8 w-full min-w-0 items-center gap-1.5 border-l-2 pr-2 text-left text-[12px]',
            active ? 'border-slate-900 bg-slate-100 text-slate-950' : 'border-transparent text-slate-700 hover:bg-slate-50'
        ].join(' ');
    }

    public treeToggleIconClass(node: any) {
        if (!node || !node.is_directory) return 'fa-regular fa-file w-3 text-center text-[11px] text-slate-400';
        if (node.loading) return 'fa-solid fa-rotate-right w-3 animate-spin text-center text-[10px] text-slate-400';
        return node.expanded
            ? 'fa-solid fa-chevron-down w-3 text-center text-[10px] text-slate-400'
            : 'fa-solid fa-chevron-right w-3 text-center text-[10px] text-slate-400';
    }

    public fileIconClass(item: any) {
        const viewer = this.normalizedViewer(item);
        if (!item) return 'fa-regular fa-file text-[13px] text-slate-500';
        if (item.is_directory || item.type === 'directory') return 'fa-solid fa-folder text-[13px] text-amber-500';
        if (viewer === 'markdown') return 'fa-regular fa-file-lines text-[13px] text-slate-600';
        if (viewer === 'html') return 'fa-regular fa-file-code text-[13px] text-orange-500';
        if (viewer === 'image') return 'fa-regular fa-file-image text-[13px] text-cyan-600';
        if (viewer === 'code') return 'fa-regular fa-file-code text-[13px] text-indigo-600';
        return 'fa-regular fa-file text-[13px] text-slate-500';
    }

    public async clickTreeNode(node: any) {
        if (!node) return;
        if (node.is_directory || node.type === 'directory') {
            await this.toggleDirectory(node);
            return;
        }
        await this.openFileTab(node);
    }

    public async toggleDirectory(node: any) {
        if (!node || !(node.is_directory || node.type === 'directory')) return;
        if (!node.loaded) {
            await this.loadTree(node.path || '', node);
            return;
        }
        node.expanded = !node.expanded;
        await this.renderView();
    }

    public findTreeNode(path: string, node: any = this.rootNode): any {
        const target = this.cleanPath(path);
        if (this.cleanPath(node && node.path || '') === target) return node;
        for (const child of node.children || []) {
            const found = this.findTreeNode(target, child);
            if (found) return found;
        }
        return null;
    }

    public async revealPath(path: string) {
        const target = this.cleanPath(path);
        if (!target) return;
        const parts = target.split('/').filter((part) => !!part);
        let current = this.rootNode;
        let currentPath = '';
        for (let i = 0; i < parts.length; i++) {
            if (!current.loaded) await this.loadTree(current.path || '', current);
            current.expanded = true;
            currentPath = currentPath ? `${currentPath}/${parts[i]}` : parts[i];
            const child = (current.children || []).find((item: any) => this.cleanPath(item.path || '') === currentPath);
            if (!child) break;
            if (child.is_directory || child.type === 'directory') {
                current = child;
                if (i === parts.length - 1 && !child.loaded) await this.loadTree(child.path || '', child);
            } else {
                await this.openFileTab(child);
                break;
            }
        }
    }

    public async refreshTree() {
        this.rootNode = this.blankRootNode();
        await this.loadTree('', this.rootNode);
    }

    public cleanPath(value: any) {
        return String(value || '').replace(/\\/g, '/').replace(/^\/+/, '').replace(/\/+$/, '');
    }

    public baseName(path: any) {
        const parts = this.cleanPath(path).split('/').filter((part) => !!part);
        return parts.length ? parts[parts.length - 1] : 'root';
    }

    public parentPath(path: any) {
        const parts = this.cleanPath(path).split('/').filter((part) => !!part);
        parts.pop();
        return parts.join('/');
    }

    public async openFileTab(item: any) {
        if (!item || item.is_directory || item.type === 'directory') return;
        const path = this.cleanPath(item.path || '');
        if (!path) return;
        let tab = this.tabs.find((row: any) => row.path === path);
        if (!tab) {
            tab = this.blankTab(item);
            this.tabs.push(tab);
        }
        this.activeTabPath = path;
        this.activePath = path;
        await this.renderView();
        if (!tab.loaded && !tab.loading) await this.loadTabFile(tab);
    }

    public blankTab(item: any) {
        const viewer = this.normalizedViewer(item);
        return {
            path: this.cleanPath(item.path || ''),
            name: item.name || this.baseName(item.path),
            mime: item.mime || '',
            viewer,
            language: item.language || '',
            file: null,
            loading: false,
            loaded: false,
            error: '',
            viewMode: this.defaultViewMode(viewer),
            original: '',
            draft: '',
            dirty: false,
            htmlPreviewCacheKey: '',
            htmlPreviewCacheUrl: ''
        };
    }

    public async loadTabFile(tab: any) {
        if (!tab || !tab.path) return;
        tab.loading = true;
        tab.error = '';
        await this.renderView();
        const { code, data } = await wiz.call('load_project_file', this.requestParams({
            id: this.projectId,
            path: tab.path
        }));
        tab.loading = false;
        if (code === 200) {
            const file = data.file || null;
            tab.file = file;
            tab.loaded = true;
            tab.name = file && file.name ? file.name : tab.name;
            tab.mime = file && file.mime ? file.mime : tab.mime;
            tab.viewer = this.normalizedViewer(file || tab);
            tab.language = file && file.language ? file.language : tab.language;
            tab.original = this.fileContent(file);
            tab.draft = tab.original;
            tab.dirty = false;
            tab.viewMode = this.defaultViewMode(tab.viewer);
            tab.htmlPreviewCacheKey = '';
            tab.htmlPreviewCacheUrl = '';
        } else {
            tab.error = data.message || '파일을 열지 못했습니다.';
        }
        await this.renderView();
    }

    public fileContent(file: any) {
        if (!file || file.content === undefined || file.content === null) return '';
        return String(file.content || '');
    }

    public activeTab() {
        if (!this.activeTabPath && this.tabs.length) this.activeTabPath = this.tabs[0].path;
        return this.tabs.find((tab: any) => tab.path === this.activeTabPath) || null;
    }

    public selectTab(tab: any) {
        if (!tab) return;
        this.activeTabPath = tab.path;
        this.activePath = tab.path;
        this.renderView();
    }

    public closeTab(tab: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!tab) return;
        if (tab.dirty && !window.confirm('저장하지 않은 변경사항이 있습니다. 탭을 닫을까요?')) return;
        const index = this.tabs.findIndex((row: any) => row.path === tab.path);
        if (index < 0) return;
        this.tabs.splice(index, 1);
        if (this.activeTabPath === tab.path) {
            const next = this.tabs[Math.min(index, this.tabs.length - 1)] || this.tabs[index - 1] || null;
            this.activeTabPath = next ? next.path : '';
            this.activePath = next ? next.path : '';
        }
        this.renderView();
    }

    public closeAllTabs() {
        if (this.hasDirtyTabs() && !window.confirm('저장하지 않은 변경사항이 있습니다. 모든 탭을 닫을까요?')) return;
        this.tabs = [];
        this.activeTabPath = '';
        this.activePath = '';
        this.renderView();
    }

    public hasDirtyTabs() {
        return this.tabs.some((tab: any) => !!tab.dirty);
    }

    public normalizedViewer(item: any) {
        const viewer = String(item && item.viewer || '').toLowerCase();
        const extension = String(item && item.extension || this.extensionOf(item && item.name || item && item.path || '')).toLowerCase();
        if (viewer === 'html' || ['html', 'htm', 'xhtml'].includes(extension)) return 'html';
        if (viewer === 'markdown') return 'markdown';
        if (viewer === 'image') return 'image';
        if (viewer === 'code') return 'code';
        if (viewer === 'download' || viewer === 'downloaded') return 'download';
        return viewer || 'download';
    }

    public extensionOf(path: any) {
        const name = this.baseName(path);
        const index = name.lastIndexOf('.');
        return index >= 0 ? name.slice(index + 1).toLowerCase() : '';
    }

    public defaultViewMode(viewer: string) {
        return ['markdown', 'html', 'image'].includes(viewer) ? 'preview' : (viewer === 'code' ? 'edit' : 'unsupported');
    }

    public previewCapable(tab: any) {
        return !!tab && ['markdown', 'html', 'image'].includes(this.normalizedViewer(tab.file || tab));
    }

    public editorCapable(tab: any) {
        const viewer = this.normalizedViewer(tab && (tab.file || tab));
        return !!tab && ['markdown', 'html', 'code'].includes(viewer) && tab.loaded && !tab.error;
    }

    public tabDisplayMode(tab: any) {
        if (!tab || tab.loading) return 'loading';
        if (tab.error) return 'error';
        if (tab.viewMode === 'preview' && this.previewCapable(tab)) return 'preview';
        if (this.editorCapable(tab)) return 'edit';
        return 'unsupported';
    }

    public switchTabMode(tab: any, mode: string) {
        if (!tab) return;
        if (mode === 'preview' && !this.previewCapable(tab)) return;
        if (mode === 'edit' && !this.editorCapable(tab)) return;
        tab.viewMode = mode;
        this.renderView();
    }

    public modeButtonClass(tab: any, mode: string) {
        const active = this.tabDisplayMode(tab) === mode;
        return [
            'inline-flex h-8 items-center gap-1.5 border px-3 text-[12px] font-semibold first:rounded-l-md last:rounded-r-md',
            active ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-300 bg-white text-slate-600 hover:bg-slate-50'
        ].join(' ');
    }

    public updateTabDraft(tab: any, value: any) {
        if (!tab) return;
        tab.draft = String(value || '');
        tab.dirty = tab.draft !== String(tab.original || '');
        tab.htmlPreviewCacheKey = '';
        tab.htmlPreviewCacheUrl = '';
    }

    public async saveTab(tab: any = this.activeTab()) {
        if (!tab || !this.editorCapable(tab) || !tab.dirty || this.savingPath) return;
        this.savingPath = tab.path;
        tab.error = '';
        await this.renderView();
        const { code, data } = await wiz.call('save_project_file', this.requestParams({
            id: this.projectId,
            data: JSON.stringify({
                path: tab.path,
                content: tab.draft
            })
        }));
        this.savingPath = '';
        if (code === 200) {
            const file = data.file || tab.file;
            tab.file = file;
            tab.viewer = this.normalizedViewer(file || tab);
            tab.language = file && file.language ? file.language : tab.language;
            tab.original = this.fileContent(file);
            tab.draft = tab.original;
            tab.dirty = false;
            tab.htmlPreviewCacheKey = '';
            tab.htmlPreviewCacheUrl = '';
            await this.refreshTreePath(this.parentPath(tab.path));
        } else {
            tab.error = data.message || '파일을 저장하지 못했습니다.';
        }
        await this.renderView();
    }

    public async refreshTreePath(path: string) {
        const node = this.findTreeNode(path || '');
        if (!node) return;
        await this.loadTree(path || '', node);
    }

    public editorOptions(tab: any) {
        this.editorOptionsCache.language = (tab && tab.language) || 'plaintext';
        this.editorOptionsCache.readOnly = !!this.savingPath;
        return this.editorOptionsCache;
    }

    public htmlPreviewUrl(tab: any) {
        if (!tab) return '';
        const file = tab.file || {};
        if (file.url && !tab.dirty) return file.url;
        const content = String(tab.draft || file.content || '');
        if (tab.htmlPreviewCacheKey === content && tab.htmlPreviewCacheUrl) return tab.htmlPreviewCacheUrl;
        tab.htmlPreviewCacheKey = content;
        tab.htmlPreviewCacheUrl = `data:text/html;charset=utf-8,${encodeURIComponent(content)}`;
        return tab.htmlPreviewCacheUrl;
    }

    public imagePreviewUrl(tab: any) {
        const file = tab && tab.file ? tab.file : {};
        return file.data_url || file.url || '';
    }

    public markdownHtml(value: any) {
        const text = String(value || '');
        if (this.markdownHtmlCache[text]) return this.markdownHtmlCache[text];
        let html = '';
        try {
            html = this.markdownConverter ? this.markdownConverter.makeHtml(text) : text;
        } catch (e) {
            html = text;
        }
        this.markdownHtmlCache[text] = html;
        this.markdownHtmlCacheKeys.push(text);
        if (this.markdownHtmlCacheKeys.length > 80) {
            const oldest = this.markdownHtmlCacheKeys.shift();
            if (oldest) delete this.markdownHtmlCache[oldest];
        }
        return html;
    }

    public tabTitle(tab: any) {
        if (!tab) return '';
        return `${tab.dirty ? '* ' : ''}${tab.name || this.baseName(tab.path)}`;
    }

    public activeTabMeta(tab: any) {
        if (!tab) return '';
        const file = tab.file || tab;
        const parts = [file.mime || tab.mime || 'file'];
        if (file.size_label) parts.push(file.size_label);
        if (tab.path) parts.push(tab.path);
        return parts.join(' · ');
    }

    public unsupportedMessage(tab: any) {
        if (!tab || !tab.loaded) return '파일을 미리보기로 열 수 없습니다.';
        const file = tab.file || tab;
        if (file.viewer === 'download') return '이 파일 형식은 미리보기나 Monaco 편집을 지원하지 않습니다.';
        return '지원되지 않는 파일 형식입니다.';
    }

    public downloadUrl(path: any) {
        const query = new URLSearchParams(this.requestParams({
            id: this.projectId,
            path: this.cleanPath(path)
        }) as any).toString();
        return `/wiz/api/page.projects.filebrowser/download_project_file${query ? `?${query}` : ''}`;
    }

    public async downloadTab(tab: any = this.activeTab()) {
        if (!tab || !tab.path || this.downloadingPath) return;
        this.downloadingPath = tab.path;
        tab.error = '';
        await this.renderView();
        try {
            const response = await fetch(this.downloadUrl(tab.path), { credentials: 'same-origin' });
            if (!response.ok) {
                let message = '파일을 다운로드하지 못했습니다.';
                try {
                    const data = await response.json();
                    message = data && data.message ? data.message : message;
                } catch (e) { }
                tab.error = message;
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = this.safeFileName(this.responseDownloadFileName(response, tab.name || 'download'));
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            tab.error = '파일을 다운로드하지 못했습니다.';
        } finally {
            this.downloadingPath = '';
            await this.renderView();
        }
    }

    public responseDownloadFileName(response: any, fallback: string) {
        const header = response && response.headers ? (response.headers.get('content-disposition') || '') : '';
        const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
        if (encoded && encoded[1]) {
            try {
                return decodeURIComponent(encoded[1]);
            } catch (e) { }
        }
        const quoted = /filename="?([^";]+)"?/i.exec(header);
        if (quoted && quoted[1]) return quoted[1];
        return fallback || 'download';
    }

    public safeFileName(value: any) {
        const text = String(value || 'download').replace(/[\\/:*?"<>|]+/g, '_').trim();
        return text || 'download';
    }

    public goProject() {
        const admin = this.adminMode ? '?admin=1' : '';
        window.location.href = `/projects/${encodeURIComponent(this.projectId)}/file${admin}`;
    }
}

export default PageProjectsFilebrowserComponent;